// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"76139cc6","952":"4d43c17a"}[chunkId] + ".chunk.js";
};